import { ChevronRight24 } from 'ui/icons';
import { useSMSPreviewContext } from '../context/SMSPreviewContext';
import {
  contactCardDetailName,
  contactCardDetailSection,
  contactCardDetailValue,
  contactCardDetailValueDisabled,
  contactCardHeader,
  contactCardIosAvatarImage,
  contactCardIosBackIcon,
  contactCardIosDisplayName,
  contactCardIosSubheader,
  rotate180,
} from './styles';

export const PLACEHOLDER_NUMBER = '+1 (XXX) XXX-XXXX';

export const ContactCardDetails = () => {
  const { previewContactCard } = useSMSPreviewContext();
  const isMessagingService = previewContactCard?.smsSender?.type === 'MessagingService';

  return (
    <>
      <ChevronRight24 color="#3494FB" style={{ ...rotate180, ...contactCardIosBackIcon }} />
      <div style={contactCardHeader}>
        <img
          data-test="preview-contact-card-details-imageUrl"
          style={contactCardIosAvatarImage}
          src={previewContactCard?.imageUrl}
        />
        <div data-test="preview-contact-card-details-displayName" style={contactCardIosDisplayName}>
          {previewContactCard?.displayName}
        </div>
        <div data-test="preview-contact-card-details-subheader" style={contactCardIosSubheader}>
          {previewContactCard?.subheader}
        </div>
      </div>
      <div style={contactCardDetailSection}>
        <div style={contactCardDetailName}>Phone number</div>
        <div
          data-test="preview-contact-card-details-phone-number"
          style={isMessagingService ? contactCardDetailValueDisabled : contactCardDetailValue}
        >
          {isMessagingService ? PLACEHOLDER_NUMBER : previewContactCard?.smsSender?.phoneNumber}
        </div>
      </div>
      <div style={contactCardDetailSection}>
        <div style={contactCardDetailName}>Website</div>
        <div data-test="preview-contact-card-details-website" style={contactCardDetailValue}>
          {previewContactCard?.website}
        </div>
      </div>
      <div style={contactCardDetailSection}>
        <div style={contactCardDetailName}>Email</div>
        <div data-test="preview-contact-card-details-email" style={contactCardDetailValue}>
          {previewContactCard?.email}
        </div>
      </div>
    </>
  );
};
